<li data-id="{{item.id}}" class="list-item btn {{#if item.hide}}hidden{{/if}}" {{#if allowTooltip}}title="{{item.name}}"{{/if}}>
  <div class="icon-m icon-left {{typeClass}}">
    <h3>{{item.name}}</h3>
  </div>
</li>
